import { Component, EventEmitter, Input, Output } from '@angular/core';
var HTML_TEMPLATE = "<div class=\"od-priority\" [attr.readonly]=\"readOnly == true ? true : null\" (mouseout)=\"onMouseOut()\">\n\t<div class=\"od-priority-reset\" (click)=\"onClick(0)\" (mouseover)=\"onMouseOver(0)\"></div>\n\t<div *ngFor=\"let _index of _maxIndex\" [class]=\"'od-priority-icon ' + getIconName(_index)\"\n\t (click)=\"onClick(_index + 1)\" (mouseover)=\"onMouseOver(_index + 1)\"></div>\n</div>";
var CSS_STYLE = "\n.od-priority{\n\tdisplay: flex;\n    flex-direction: row;\n    width: fit-content;\n}\n\n.od-priority-reset{\n\tcursor: pointer;\n\twidth:10px;\n}\n\n.od-priority[readonly]{\n\tpointer-events:none;\n}\n\n.od-priority-icon {\n\tcursor: pointer;\n    font-size: 22px;\n}\n\n.od-priority-icon-full:before {\n\tcursor: pointer;\n\tcolor: #fa9610;\n}\n\n.od-priority-icon-empty:before {\n\tcursor: pointer;\n\tcolor: #d8d8d8;\n}\n";
var Priority = /** @class */ (function () {
    function Priority() {
        this.change = new EventEmitter();
        this.data = 0;
        this.maxCount = 5;
        this.maxValue = 100;
        this.iconFullStyle = "od-priority-icon-full odi_starOn";
        this.iconEmptyStyle = "od-priority-icon-empty odi_starOn";
    }
    Object.defineProperty(Priority.prototype, "data", {
        set: function (value) {
            if (value != null) {
                this._data = value;
                this._viewData = this._data;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Priority.prototype, "maxCount", {
        set: function (value) {
            if (value != null)
                this._maxCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Priority.prototype, "maxValue", {
        set: function (value) {
            if (value != null)
                this._maxValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Priority.prototype.getIconName = function (index) {
        if (index < this._viewData * (this._maxIndex.length / this._maxValue)) {
            return this.iconFullStyle;
        }
        return this.iconEmptyStyle;
    };
    Priority.prototype.refresh = function () {
        if (this._maxCount != null) {
            this._maxIndex = [];
            for (var index = 0; this._maxCount > index; index++) {
                this._maxIndex.push(index);
            }
        }
    };
    Priority.prototype.onClick = function (index) {
        this._viewData = index * 100 / this._maxIndex.length;
        this._data = this._viewData;
        this.change.emit(this._data);
    };
    Priority.prototype.onMouseOver = function (index) {
        this._viewData = index * 100 / this._maxIndex.length;
        this.refresh();
    };
    Priority.prototype.onMouseOut = function () {
        this._viewData = this._data;
        this.refresh();
    };
    Priority.prototype.ngOnChanges = function (changes) {
        this.refresh();
    };
    Priority.decorators = [
        { type: Component, args: [{
                    selector: 'od-priority',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Priority.ctorParameters = function () { return []; };
    Priority.propDecorators = {
        "readOnly": [{ type: Input },],
        "iconFullStyle": [{ type: Input },],
        "iconEmptyStyle": [{ type: Input },],
        "change": [{ type: Output },],
        "data": [{ type: Input },],
        "maxCount": [{ type: Input },],
        "maxValue": [{ type: Input },],
    };
    return Priority;
}());
export { Priority };
//# sourceMappingURL=priority.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/priority/priority.js
// module id = 423
// module chunks = 14